import React, { useState } from 'react'

const AdPostingValidation = ({ isOpen, onClose, errors = [], onEditAds, onResolveErrors }) => {
  const [isModalOpen, setIsModalOpen] = useState(isOpen || false)

  const errorList = errors;
  const errorCount = errorList.length

  const handleClose = () => {
    setIsModalOpen(false)
    if (onClose) onClose()
  }

  const handleEditAds = () => {
    // Handle ignore ads action
    if (onEditAds) {
      onEditAds();
    } else {
      console.log('Ignore ads clicked');
    }
  }

  const handleResolveErrors = () => {
    // Handle resolve errors action
    if (onResolveErrors) {
      onResolveErrors();
    } else {
      console.log('Resolved errors clicked');
      handleClose();
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="w-full max-w-4xl max-h-[90vh] overflow-auto bg-white rounded-lg shadow-xl">
        <div className="p-8">
          {/* Header Section */}
          <div className="flex items-start justify-between mb-6">
            <div className="flex items-center space-x-4">
              <div className="p-3 rounded-full" style={{ backgroundColor: 'rgb(254, 243, 242)' }}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className="w-6 h-6" 
                  style={{ color: 'rgb(239, 67, 69)' }}
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" x2="12" y1="8" y2="12"></line>
                  <line x1="12" x2="12.01" y1="16" y2="16"></line>
                </svg>
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900">
                  {errorCount} Issue{errorCount !== 1 ? 's' : ''} Found
                </h2>
                <p className="mt-1 text-gray-600">
                  Resolve these issues before moving ahead with the launch.
                </p>
              </div>
            </div>
            <button 
              onClick={handleClose}
              className="text-gray-400 transition-colors hover:text-gray-600"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="w-6 h-6"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>

          {/* Table Section */}
          <div className="mb-8 overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="px-2 py-4 text-lg font-semibold text-left text-gray-800">
                    Error
                  </th>
                  <th className="px-2 py-4 text-lg font-semibold text-left text-gray-800">
                    Error Details
                  </th>
                  <th className="px-2 py-4 text-lg font-semibold text-left text-gray-800">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {errorList.map((errorItem) => (
                  <tr key={errorItem.id || `${errorItem.error}-${errorItem.errorDetails}`} className="border-b border-gray-100 last:border-b-0">
                    <td className="px-2 py-6 font-semibold text-red-700">
                      {errorItem.error}
                    </td>
                    <td className="px-2 py-6 text-gray-600">
                      {errorItem.errorDetails}
                    </td>
                    <td className="px-2 py-6 text-gray-700">
                      {errorItem.action}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Footer Section */}
          <div className="flex justify-end space-x-4">
            <button 
              onClick={handleEditAds}
              className="px-8 py-3 font-medium text-gray-700 transition-colors border-2 border-gray-300 rounded-lg hover:border-gray-400 hover:bg-gray-50 font-inter"
            >
              Ignore Errors and Proceed
            </button>
            <button 
              onClick={handleResolveErrors}
              className="px-8 py-3 font-medium text-white transition-colors rounded-lg hover:opacity-90 font-inter" 
              style={{ backgroundColor: 'rgb(110, 102, 237)' }}
            >
              I have resolved the errors
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdPostingValidation